import LoadingBar from 'react-top-loading-bar';

export default function Loader({ loaderRef }) {
  return <LoadingBar height={4} color="#dd090f" ref={loaderRef} style={{ margin: '0px', padding: '0px' }} />;
}
